import { csvApi } from '../api/CsvApi';
import { api } from '../api/api';
import Event from '../models/Event';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { PostMethods } from '../api/postmethods';
import DateTime from '../models/DateTime';
import { pdfApi } from '../api/PdfApi';
import { API_PDF_PREFIX } from '../constants';
import _ from 'lodash';

const cleanString = (string) => {
  const alphaNumeric = _.chain(string).replace(/[^A-Za-z0-9]/g, ' ').split(' ').filter(s => !!s).join(' ').value();
  const regex = /[\\/:"*?<>|]/g;
  return alphaNumeric.replace(regex, '');
};

export const popFileFetch = {
  csv (event, collection = null) {
    return csvApi.csvDownloadUri(Event.getId(event));
  },
  async zipPdfs (events, updateProgressBar, closeDialog) {
    const totalPopins = events.length;
    const increment = 100 / totalPopins;
    const zip = new JSZip();
    const zipFolderName = `POPin Results - ${DateTime.format(DateTime.now(), 'MMM Do YYYY')}.zip`;
    const urls = [];

    try {
      for (let i = 0; i < events.length; ++i) {
        const pdfUrl = await pdfApi.fetchPdf(Event.getSlug(events[i]), [], []);
        urls.push(pdfUrl);
        updateProgressBar(increment, i + 1, totalPopins);
      }

      await Promise.all(urls.map((string, i) => {
        const url = 'https://' + window.location.hostname + API_PDF_PREFIX + '/' + string;

        return api.raw(PostMethods.GET, url).then((data) => {
          const fileName = cleanString(events[i].name);
          const length = Math.min(50, fileName.length);
          const fileNameTruncated = fileName.substring(0, length);
          const fileNameNoSpaces = fileNameTruncated.split(' ').join('_');
          zip.file(`0${i + 1}_${fileNameNoSpaces}.pdf`, data.blob());
        });
      }));

      const blob = await zip.generateAsync({
        type: 'blob'
      });
      setTimeout(saveAs, 2000, blob, zipFolderName);
      setTimeout(closeDialog, 2000);
    } catch (err) {
      closeDialog();
    }
  }
};
